import instance from './instance';

export const createSubscription = data => instance(`/api/v0/subscriptions`, { method: 'POST', data });

export const updateSubscription = subscription =>
  instance(`/api/v0/subscriptions/${subscription.id}`, { method: 'PUT', data: subscription });

export const switchToAnnualPlan = data =>
  instance(`/api/v0/subscriptions/switch_to_annual_plan`, { method: 'PUT', data });

export const getActiveSubscription = () => instance('/api/v0/subscriptions/active');

export const updateCreditCard = data => instance('/api/v0/subscriptions/update_card', { method: 'PUT', data });

export const cancelSubscription = () => instance('/api/v0/subscriptions/cancel', { method: 'PUT' });

export const chooseFreePlan = data => instance('/api/v0/subscriptions/choose_free_plan', { method: 'PUT', data });

export const fetchPlanInfo = params => instance.get(`/subscriptions/get_plans_v2`, { params });

export const updateSubscriptionDetails = data => instance.put('/subscriptions/plan_change', { data });
